export default "__VITE_ASSET__NP8PW7M6__"